import { render, staticRenderFns } from "./orderdetail.vue?vue&type=template&id=35b9cd2e&scoped=true"
import script from "./orderdetail.vue?vue&type=script&lang=js"
export * from "./orderdetail.vue?vue&type=script&lang=js"
import style0 from "./orderdetail.vue?vue&type=style&index=0&id=35b9cd2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b9cd2e",
  null
  
)

export default component.exports